module.exports = __webpack_public_path__ + "img/slack.6a79316b.png";